import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "silvia_admin_token";

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err?.response?.status === 401) {
            const path = window.location.pathname;
            if (path.startsWith("/admin") && path !== "/admin/login") {
                localStorage.removeItem(TOKEN_KEY);
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    },
);

export const auth = {
    async login(username, password) {
        const { data } = await api.post("/auth/login", { username, password });
        localStorage.setItem(TOKEN_KEY, data.access_token);
        return data;
    },
    async me() {
        const { data } = await api.get("/auth/me");
        return data;
    },
    logout() {
        localStorage.removeItem(TOKEN_KEY);
    },
    token() {
        return localStorage.getItem(TOKEN_KEY);
    },
    isLogged() {
        return Boolean(localStorage.getItem(TOKEN_KEY));
    },
};

export const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });

// Compress and resize images on client before upload to avoid exceeding backend
// payload limits and bloating MongoDB. Resizes the longest edge to maxSide and
// re-encodes as JPEG. Defaults tuned for fast page loads (~80-150 KB).
export const compressImage = (file, maxSide = 1280, quality = 0.78) =>
    new Promise((resolve, reject) => {
        if (!file.type.startsWith("image/")) {
            reject(new Error("No es una imagen"));
            return;
        }
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            const ratio = Math.min(1, maxSide / Math.max(img.width, img.height));
            const w = Math.round(img.width * ratio);
            const h = Math.round(img.height * ratio);
            const canvas = document.createElement("canvas");
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, w, h);
            const dataUrl = canvas.toDataURL("image/jpeg", quality);
            URL.revokeObjectURL(url);
            resolve(dataUrl);
        };
        img.onerror = (e) => {
            URL.revokeObjectURL(url);
            reject(e);
        };
        img.src = url;
    });

export const formatError = (err) => {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Algo salió mal";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    return String(d);
};
